<span id="findResultsCount" class="toolbarLabel hidden"></span>
